import L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet/dist/leaflet.css'
import {FC, useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {ITransactionInfoMap, MapEquipmentsStatistics} from './core/_models'
import {getTransactionInformationMap} from './core/_requests'

const MapClusterAsset: FC = () => {
  const [equipmentsStatistics, setEquipmentsStatistics] = useState<MapEquipmentsStatistics[]>([])
  const mapRef = useRef<HTMLDivElement>(null)
  const mapInstanceRef = useRef<L.Map | null>(null)
  const intl = useIntl()

  const getEquipments = async () => {
    const {data} = await getTransactionInformationMap()
    if (data) {
      setEquipmentsStatistics(data)
    }
  }

  useEffect(() => {
    // getEquipments()

    if (mapRef.current && !mapInstanceRef.current) {
        const map = L.map(mapRef.current).setView([-14.235, -51.9253], 4)
        map.attributionControl.setPrefix(false)
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)
    
        mapInstanceRef.current = map
        
        const markers = L.markerClusterGroup()
        map.addLayer(markers)
    }
  }, [])

  useEffect(() => {
    if (equipmentsStatistics && equipmentsStatistics.length > 0) {
    }
  }, [equipmentsStatistics])

  return (
    <div className='d-flex'>
      <div
        className='rounded'
        ref={mapRef}
        style={{display: 'flex', height: '66vh', width: '100vw'}}
      />
    </div>
  )
}

export default MapClusterAsset
